import React from "react"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import Card from "./Card"
import makeStyles from "@mui/styles/makeStyles"
import { COLORS } from "../../utils"
import Divider from "@mui/material/Divider"
import moment from "moment"
import clsx from "clsx"
import { compareByUniqueCode } from "../../utils/receptionUtils"

const useStyles = makeStyles(() => ({
    listItem: {
        padding: "0 6px 19px 34px"
    },
    title: {
        flex: "0 0 auto",
        width: 55,
        marginTop: 21,
        "& span": {
            color: COLORS.PRIMARY_COLOR,
            fontSize: 42,
            fontWeight: "bold"
        }
    },
    title2: {
        composes: "$title",
        "& span": {
            fontSize: 30,
            paddingTop: 10
        }
    },
    groupCard: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            width: 80,
            height: 80,
            margin: "17px 10px 0 0",
            background: COLORS.WHITE,
            boxShadow: `0px 1px 1px ${COLORS.BLUE_PAPER_SELECTED}`,
            borderRadius: 10
        },
    },
    // KFC-352: the inventory tile is taller — it carries the stock cells underneath the code
    // and the DLC. Reception keeps its 80px tiles.
    groupCardInventory: {
        "& > *": {
            // KFC-352: 116x100 including the border, measured on the DSG-36 prototype.
            width: 116,
            height: 100,
            boxSizing: "border-box",
            justifyContent: "space-between",
            overflow: "hidden",
        },
    }
}))


const ListCard = (props) => {
    const { title, listItem, last, onCardClick, selectedCard, isInventory, canEdit, fridgeFilter, hasRetailOffer } = props
    const classes = useStyles()
    // KFC-352: the taller tile exists to carry the stock cells. A hub without a retail offer
    // has none, so keeping the tall grid would only leave an empty band under the DLC.
    const showRetailInventory = isInventory && Boolean(hasRetailOffer)
    // KFC-352: order by product number rather than by string — see compareByUniqueCode.
    // `sort` mutates its array, so copy first: this list comes straight from the Redux state.
    const listItemSorted = [...listItem].sort(compareByUniqueCode)
    return (
        <>
            <ListItem className={classes.listItem} alignItems="flex-start">
                <ListItemText className={(title.length === 2) ? classes.title2 : classes.title} primary={title} />
                <div className={clsx(classes.groupCard, { [classes.groupCardInventory]: showRetailInventory })}>
                    {
                        listItemSorted && listItemSorted.map((cardElement) => {
                            const date = moment.utc(cardElement.dlc)
                            const displayDate = date.isSame(new Date(), "year")
                                ? date.format("DD/MM")
                                : date.format("DD/MM/YY")

                            return <Card
                                key={title + cardElement.objectId}
                                type={title}
                                number={cardElement.uniqueCode.replace(title, "")}
                                date={displayDate}
                                done={isInventory ? (cardElement.checked) : (cardElement.receptionStatus === "DONE")}
                                onCardClick={onCardClick}
                                element={cardElement}
                                selectedCard={selectedCard}
                                isInventory={isInventory}
                                fridgeFilter={fridgeFilter}
                                hasRetailOffer={hasRetailOffer}
                                canEdit={canEdit}
                            />
                        })
                    }
                </div>
            </ListItem>
            {!last &&
                <Divider component="li" />
            }
        </>
    )
}

export default ListCard